var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enquiryList m-b-100"},[(_vm.lists && _vm.lists.length > 0)?_c('div',[_c('inquiry-item',{attrs:{"lists":_vm.lists},on:{"undo":_vm.undoHandle}})],1):_c('z-empty',{attrs:{"txt":"暂时还没有询价单哦！","sl":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }